module.exports = __webpack_public_path__ + "img/桌卡2.8f4aeb69.png";